import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import type { ChatMessageEmojiInputInsertReaction } from '@/components/Chat/ChatMessageEmojiInput';
import { ChatMessageEmojiInputFragment } from '@/components/Chat/ChatMessageEmojiInput.utils';
import { type ResultOf, readFragment } from '@/gql/graphql';
import useAuthStore from '@/stores/useAuthStore';

export default function insert_message_reaction_one(
  parent: {
    insert_message_reaction_one: ResultOf<
      typeof ChatMessageEmojiInputInsertReaction
    >['insert_message_reaction_one'];
  },
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  const message = readFragment(
    ChatMessageEmojiInputFragment,
    parent.insert_message_reaction_one?.message,
  );
  const personId = useAuthStore.getState().uid;

  if (!message || !personId) {
    return;
  }

  cache.writeFragment(ChatMessageEmojiInputFragment, message, {
    personId,
  });
}
